import { useMemo, useRef } from 'react'

interface Props<T> {
    value: T
    comparisonFunction?: (originalValue: T, newValue: T) => boolean
}

// Will determine if a field has updated to trigger a nextFetchPolicy
export function useRefetchOnUpdate<T>({ value, comparisonFunction }: Props<T>) {
    const lastSavedValue = useRef<T>(value)

    const hasValueChanged = useMemo(() => {
        if (comparisonFunction) {
            const result = comparisonFunction(lastSavedValue.current, value)
            lastSavedValue.current = value
            return result
        }

        const retResult = value !== lastSavedValue.current
        lastSavedValue.current = value
        return retResult
    }, [value, lastSavedValue])

    return hasValueChanged
}
